import React from 'react';
import PropTypes from 'prop-types';
import { Section } from 'components/atoms';
import './CityCardList.scss';
import CityCard from '../../molecules/CityCard/CityCard';

const CityCardList = ({ drilldownLinks }) => {
	if (!drilldownLinks || drilldownLinks.length === 0) return null;
	return (
		<Section className="city-card-list">
			{drilldownLinks.map((cityData) => (
				<div key={cityData.city + '-' + cityData.state}>
					<CityCard cityData={cityData} />
				</div>
			))}
		</Section>
	);
};

CityCardList.propTypes = {
	drilldownLinks: PropTypes.arrayOf(PropTypes.object),
};

CityCardList.defaultProps = {
	drilldownLinks: [],
};

export default CityCardList;
